var assignmentService = {};
export {
  assignmentService as __exports
};
//# sourceMappingURL=assignment-service.js.map
